
namespace Matrix.DataAudit {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class AccountHistoryEditDialog extends SiteEntityDialog<AccountHistoryRow, any> {
        protected getFormKey() { return AccountHistoryForm.formKey; }
        protected getIdProperty() { return AccountHistoryRow.idProperty; }
        protected getLocalTextPrefix() { return AccountHistoryRow.localTextPrefix; }
        protected getNameProperty() { return AccountHistoryRow.nameProperty; }
        protected getService() { return AccountHistoryService.baseUrl; }

        protected form = new AccountHistoryForm(this.idPrefix);

        protected initToolbar() {
            super.initToolbar();

            var rngDiv = $(`<div class="history-range"><span>Effective Date Range</span>
<input type="text" class="history-range-start" style="width: 90px" />
<span class="sep">-</span>
<input type="text" class="history-range-end" style="width: 90px" />
</div>`).appendTo(this.toolbar.element);

            var start = new Serenity.DateEditor(rngDiv.children('.history-range-start'));
            var end = new Serenity.DateEditor(rngDiv.children('.history-range-end'));

            rngDiv.find('.ui-datepicker-trigger').css({
                position: 'relative',
                top: '3px'
            });

            var datesChange = () => {
                if (start.valueAsDate && end.valueAsDate && start.valueAsDate < end.valueAsDate && this.entity.AccountCode)
                    this.editHistory(this.entity.AccountCode, start.valueAsDate, end.valueAsDate);
                //this.refresh();
            };
            start.element.add(end.element).change(datesChange);
        }

        protected updateTitle() {
            this.dialogTitle = "Edit Account History " + this.entity.AccountCode;
        }

        protected getInsertPermission() {
            return "DataAdmin:AccountHistory";
        }

        protected useViewMode() {
            return false;
        }

        protected updateInterface() {
            super.updateInterface();
            this.applyChangesButton.hide();
            Serenity.EditorUtils.setReadOnly(this.form.AccountCode, true);
        }

        protected getPropertyItems() {
            return super.getPropertyItems().filter(x =>
                x.name != AccountHistoryRow.Fields.DateFrom &&
                x.name != AccountHistoryRow.Fields.DateTo &&
                x.name != AccountHistoryRow.Fields.CurrentFrom &&
                x.name != AccountHistoryRow.Fields.CurrentTo &&
                x.name != AccountHistoryRow.Fields.IsCurrent &&
                x.name != AccountHistoryRow.Fields.Generation &&
                x.name != AccountHistoryRow.Fields.Status &&
                x.tab != "Version Info");
        }

        protected validateBeforeSave() {
            if (!super.validateBeforeSave())
                return false;

            var start = this.toolbar.element.find('.history-range-start').getWidget(Serenity.DateEditor).valueAsDate;
            var end = this.toolbar.element.find('.history-range-end').getWidget(Serenity.DateEditor).valueAsDate;
            if (!start || !end || start > end) {
                Q.notifyError('Please enter a valid date range!');
                return false;
            }

            return true;
        }

        protected getSaveEntity() {
            var entity = super.getSaveEntity();
            var s = this.toolbar.element.find('.history-range-start').getWidget(Serenity.DateEditor).valueAsDate;
            var e = this.toolbar.element.find('.history-range-end').getWidget(Serenity.DateEditor).valueAsDate;
            entity.DateFrom = Q.formatDate(s, 'yyyy-MM-dd');
            entity.DateTo = Q.formatDate(e, 'yyyy-MM-dd');
            return entity;
        }

        public editHistoryWith(ent: AccountHistoryRow, dialogOpen?: boolean) {
            delete ent.AccountKey;
            delete ent.CreatedBy;
            delete ent.CreatedWhen;
            delete ent.UpdatedBy;
            delete ent.UpdatedWhen;
            delete ent.Version;
            delete ent.RowId;
            delete ent.SourceCreatedBy;
            delete ent.SourceCreatedWhen;
            delete ent.SourceUpdatedBy;
            delete ent.SourceUpdatedWhen;
            if (dialogOpen)
                this.loadEntityAndOpenDialog(ent);
            else
                this.loadEntity(ent);

            this.toolbar.element.find('.history-range-start').getWidget(Serenity.DateEditor).value = ent.DateFrom;
            this.toolbar.element.find('.history-range-end').getWidget(Serenity.DateEditor).value = ent.DateTo;
        }

        public editHistory(accountCode: string, dateStart, dateEnd: Date, dialogOpen?: boolean) {

            AccountHistoryService.GetDateMatch({
                AccountCode: accountCode,
                StartDate: Q.formatDate(dateStart, 'yyyy-MM-dd') + 'T00:00:00Z',
                EndDate: Q.formatDate(dateEnd, 'yyyy-MM-dd') + 'T00:00:00Z'
            },
                response => {
                    var ent = response.Entity;
                    if (!ent) {
                        if (dialogOpen) {
                            Q.notifyError("No matching record found!");
                            return;
                        }
                    }
                    else {
                        delete ent.DateFrom;
                        delete ent.DateTo;
                        ent.DateFrom = Q.formatDate(dateStart, 'yyyy-MM-dd');
                        ent.DateTo = Q.formatDate(dateEnd, 'yyyy-MM-dd');
                        this.editHistoryWith(ent, dialogOpen);
                    }
                }
            );
        }

        protected get hasPendingChanges() {
            return false;
        }
    }
}